import { IconButton, Input, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import { connect } from 'react-redux';
import { setLabourFilterKey, setSelection } from '../../store/actions';
import SelectDialog from '../../components/SelectDialog';
import LabourTable from './labour';
import SelectedChip from './selected';

const useStyles = makeStyles((theme) => ({
  root: {
    color: 'white',
    padding: '2px',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    width: '97%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  }
}));


function SelectLabour(props) {
  const classes = useStyles();

  return (
    <SelectDialog
      open={props.open}
      title={props.defect + ' Hizmeti ' + props.title}
      onClose={props.onClose}
      onEntering={() => props.setLabourFilterKey("")}
      actions={false}
      SearchField={
        <div className={classes.fields}>
          <Input
            onChange={(event) => props.setLabourFilterKey(event.target.value)}
            value={props.labours?.filterKey}
            endAdornment={<InputAdornment position="end">
              <IconButton
                edge="end">
                <SearchIcon />
              </IconButton>
            </InputAdornment>}
            aria-describedby="standard-weight-helper-text"
            placeholder="İşçilik kodu ya da adını giriniz..."
          />
        </div>
      }
      SelectedItems={<SelectedChip defect={props.defect} />}
    >
      <LabourTable defect={props.defect} garantiTipi={props.garantiTipi} />
    </SelectDialog>
  );
}

const mapStateToProps = (state) => ({
  defects: state.defectReducer,
  labours: state.labourReducer,
});

const mapDispatchToProps = {
  setSelection: setSelection,
  setLabourFilterKey: setLabourFilterKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectLabour)
